import i18next from 'i18next';

/** Registers English strings for the Connections UI (`connection-ui` namespace). */
export default function initI18n(): void {
  i18next.addResourceBundle('en', 'connection-ui', {
    title: 'Composio Connections',
    connectionsDescription:
      'Connect your apps and link SaaS accounts so agents can use them in chat.',
    addConnection: 'Add connection',
    connectionActions: 'Connection actions',
    emptyStateTitle: 'No connections yet',
    emptyStateDescription: 'Connect a popular app to get started, or browse the full catalog.',
    moreConnections: 'More...',
    toolkitToolCount: '{{count}} tools',
    toolkitTriggerCount: '{{count}} triggers',
    toolkitVersion: 'v{{version}}',
    toolkitUpdatedAt: 'Updated {{date}}',
    noToolkitsFound: 'No connections match your search.',
    loadMoreToolkits: 'Load more',
    toolkitNotConnectable: 'This connection cannot be completed right now.',
    existingConnectionsHint: 'Already connected: {{names}}',
    nameRequired: 'Name',
    groupActive: 'Active',
    groupNeedsAttention: 'Needs attention',
    groupPending: 'Pending',
    groupRecommended: 'Recommended',
    metricConnect: 'Connect',
    metricRecommended: 'Not connected',
    metricConnectedOnDevice: 'Connected on {{device}}',
    metricLastSynced: 'Last synced {{date}}',
    metricSyncing: 'Syncing… {{done}}/{{total}}',
    metricSyncError: 'Sync failed: {{error}}',
    metricResync: 'Re-sync',
    metricConnectionSettings: 'Connection settings',
    metricDescriptionHealthkit:
      'Sync steps, sleep, heart rate, and other health data from Apple Health on your iPhone.',
    metricDescriptionHealthConnect:
      'Sync steps, sleep, heart rate, and other health data from Health Connect on your Android phone.',
    metricDescriptionOura:
      'Sync sleep, readiness, activity, and heart rate from your Oura ring every day.',
    rename: 'Rename',
    connectionRenamed: 'Connection renamed',
    reconnect: 'Reconnect',
    refreshStatus: 'Refresh status',
    enable: 'Enable',
    disconnect: 'Disconnect',
    disconnectConfirmDescription:
      'This will remove the {{name}} connection. Agents will no longer be able to use it.',
    disconnectMetricConfirmDescription:
      'This will disconnect {{name}}. Metric sync from this source will stop until you reconnect.',
    disconnectedToast: '{{name}} disconnected',
    delete: 'Delete',
    deleteMetricConfirmDescription:
      'This will permanently delete the {{name}} connection and all metrics synced from it.',
    deletedToast: '{{name}} deleted',
    setAsDefault: 'Set as default',
    toolAccessMode: 'Access',
    toolAccessModeReadOnly: 'Read only',
    toolAccessModeReadWrite: 'Read + write',
    enableReadWrite: 'Allow read + write',
    switchToReadOnly: 'Switch to read only',
    finishInOtherWindow: 'Finish the sign-in in the other window.',
    checkNow: 'I have finished — check now',
    cancelPending: 'Cancel',
    defaultAccountBadge: 'Default account',
    personalBadge: 'Personal',
    spaceBadge: 'Space',
    serviceBadge: 'Service',
    connectedAt: 'Connected {{date}}',
    verifiedAt: 'Verified {{date}}',
    scopeJustMe: 'Just me',
    scopeEveryoneInSpace: 'Everyone in my space',
    scopeEveryoneInSpaceNamed: 'Everyone in {{name}}',
    scopePermanentWarning:
      'Space connections cannot be switched back to personal later. Disconnect and reconnect to change scope.',

    // Add connection dialog
    chooseToolkitTitle: 'Choose a connection',
    connectTitle: 'Connect',
    alreadyConnectedCount: '{{count}} connected',
    maxAccountsReached: 'Maximum accounts connected',
    authSchemeChoice: 'Authentication method',
    scopeChoice: 'Share with',
    toolAccessModeChoice: 'Tool access',
    toolAccessModeChoiceHintReadOnly: 'Read only limits agents to viewing data.',
    toolAccessModeChoiceHintReadWrite: 'Read + write also allows agents to make changes.',
    schemeSignInWith: 'Sign in with {{name}}',
    schemeUseAccessToken: 'Use an access token',
    schemeUseApiKey: 'Use an API key',
    fieldVercelBearerToken: 'Bearer token',
    fieldVercelTeamId: 'Team ID (optional)',
    fieldNeonApiKey: 'API key',
    connectButton: 'Connect',
    back: 'Back',
    finish: 'Done',
    cancel: 'Cancel',
    confirmTitle: 'Connected',
    connectionSuccessDescription: 'You can now use {{name}} in chat.',
    oauthWaitingDescription: 'Complete the sign-in in the new window, then come back here.',
    oauthFailedDescription: 'The connection was not completed. You can try again.',

    // AI tool component (connectToolkit)
    connectToolkitCardConnect: 'Connect',
    connectToolkitCardSkip: 'Skip',
    connectToolkitCardContinue: 'I have connected — continue',
    connectToolkitCardConnected: 'Connected {{name}}',
    connectToolkitCardSkipped: 'Skipped',
    connectToolkitCardNotConnected:
      'No active {{name}} connection was found. Connect it first, then continue.',
  });
}
